<template>
  <EXDialog
    :title="title"
    :label="label"
    :showVisible="curShowChoose"
    width="25%"
    @close="close"
  >
    <div class="departments">
      <div class="search">
        <span style="width: 0.8rem; margin-right: 0.1rem">部门 :</span>
        <el-input v-model="keyWords" placeholder="可根据关键词过滤"></el-input>
        <el-button
          v-show="showCheckbox"
          type="primary"
          style="margin-left: 0.1rem"
          @click="sureSelect"
          >确定</el-button
        >
        <el-button
          type="primary"
          style="margin-left: 0.1rem"
          @click="resetKeyword"
          >重置</el-button
        >
      </div>
      <div style="height: 4rem">
        <ETree
          ref="fatherTree"
          :treeList="treeList"
          :showCheckbox="showCheckbox"
          :ifEditMenu="false"
          nodeWidth="100%"
          @fetchTableData="clickNode"
          @checkTreeData="handleCheckChange"
        />
      </div>
    </div>
  </EXDialog>
</template>

<script>
import ETree from "@/components/EXTree/tree.vue";
import EXDialog from "./index.vue";
import apiDict from '@/api/gate/apiDict'
export default {
  name: 'EXChooseDepartment',
  components: {
    ETree,
    EXDialog
  },
  props: {
    closeDilog: Function,
    title: String,
    label: String,
    showChoose: Boolean,
    showCheckbox:Boolean,
    //父部门编码
    orgCode: Number,
    //部门树数据：优先于orgCode
    treeData:{
      type:Array,
      default: ()=>([])
    },
  },
  computed:{
    curShowChoose(){
      return this.showChoose
    }
  },
  data() {
    return {
      keyWords: "",
      timer: null,
       // 树对应的list，设为空
       treeList: [],
       checkedList:[], //多选
    }
  },
  mounted(){
    if(this.orgCode && this.orgCode != ''){
      this.handleTree()
    }
    if(this.treeData && this.treeData.length > 0){
      this.treeList = this.treeData;
    }
  },
  watch: {
    keyWords: {
      handler() {
        if (this.timer) {
          clearTimeout(this.timer);
        }
        this.timer = setTimeout(() => {
          this.handleSearch();
        }, 200);
      },
      deep: true,
    },
    treeData (val) {
      this.treeList = val;
    },
  },
  methods: {
    async handleTree(){
        let res = await apiDict.getOrgCodeTree({orgCode:this.orgCode}) //树数据
        const body = res && res.body ? res.body : {}
        const list = body.treeList || []
        let treeList = this.modifyTreeConfigNoNumber(list)
        this.treeList = treeList   
    },
     //递归树构造
    modifyTreeConfigNoNumber(list){
      if(list!=null && list.length > 0){
        return list.map(e => ({ label: e.orgName, treeKey: e.orgId,children:this.modifyTreeConfigNoNumber(e.children)}))
      }
    },
    handleSearch() {
      this.$refs.fatherTree.$refs.tree.filter(this.keyWords);
    },
    clickNode(node) {
      this.$emit("closeDilog", node);
    },
    handleCheckChange(item) {
      if(item.isChecked){  //被选中
        this.checkedList.push(item.nodeObj)
      }else{ //取消选中
        this.checkedList.splice(this.checkedList.indexOf(item.nodeObj), 1)
      }
     },
    //重置
    resetKeyword() {
      this.keyWords = "";
    },
    //确定
    sureSelect(){
      if(!this.checkedList || this.checkedList.length == 0) {
        this.$emit("sureSelect","","");
      }else{
        const keys = []
        const labels = []
        this.checkedList.forEach(item => {
          keys.push(item.treeKey)
          labels.push(item.label)
        })
       this.$emit("sureSelect", keys.join(),labels.join());
      }
    },
    close() {
      this.$emit('closeDilog')
    },
  },
};
</script>

<style lang="scss" scoped>
.search {
  display: flex;
  align-items: center;
}
/deep/ .el-dialog {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  margin-top: 0 !important; // 覆盖15vh
}
.el-tree {
  height: 4rem;
  overflow-y: auto;
}
</style>


// WEBPACK FOOTER //
// src/components/EXDialog/EXChooseDepartment.vue